/* src/contexts/profile/profileConstants.js */

export const LOCAL_STORAGE_KEY = 'dualNBackActiveProfileId';
export const MAX_PROFILES_PER_USER = 6;

export const DEFAULT_PROFILE_DATA = {
    // No username here by default in the structure for Firestore creation
    currentNBack: 2,
    currentDifficulty: 0.0,
    highestNBack: 2,
    consecutiveSuccesses: 0,
    journalTags: [],
    cstHistory: [],
    tutorialsCompleted: {},
    cstFamiliarizationCount: 0,
    lastCstAssessmentTimestamp: null,
    createdAt: null, // Set by serverTimestamp or loaded
    updatedAt: null, // Set by serverTimestamp or loaded
};